import { ActivityKind } from "@visioni/a3s-activity-recorder/types";

/**
 * The `kinds` query parameter for an activity list request.
 *
 * With no kind selected this asks for every kind this build knows rather than
 * leaving the filter off, so the server never returns rows the app cannot
 * render and `totalCount` matches what the list can show. The server ANDs the
 * filter with what the caller may see, so for an up-to-date build this is the
 * same as no filter.
 */
export function activityKindsParam(selected: readonly ActivityKind[]): string {
  return (selected.length > 0 ? selected : ActivityKind.options).join(",");
}
